<template>
    <div id="something1">
        <ejs-progressbar v-bind:id="progressbarId" type='Linear'
                         :trackThickness='trackThickness'
                         :progressThickness='progressThickness'
                         :value='dataField'
                         height='20'
                         width="200"
                         isGradient=true
                         :rangeColors=range
                         :labelStyle='labelStyle'
                         :showProgressValue='showProgressValue'
                         :animation='animation'> </ejs-progressbar>
    </div>
</template>

<script>
    import Vue from "vue";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import {
        ProgressBarPlugin,
    } from "@syncfusion/ej2-vue-progressbar";

    Vue.use(ProgressBarPlugin);

    Vue.use(ButtonPlugin);
    export default {
        name: 'ColumnTemplate',
        data() {
            return {
                data: {},

                range: [
                    { start: 0, end: 20, color: "grey" },
                    { start: 20, end: 40, color: "darkGray" },
                    { start: 40, end: 60, color: "darkGrey" },
                    { start: 60, end: 80, color: "lightGrey" },
                    { start: 80, end: 100, color: "white" },
                ],
                trackThickness: 24,
                progressThickness: 24,
                animation: {
                    enable: true,
                    duration: 1000,
                    delay: 0,
                },
                labelStyle: {
                    color: "black",
                },
                showProgressValue: true,
            }
        },
        methods: {
        },
        computed: {
            dataField: function () {
                return parseInt(this.data[this.data.column.headerText]);
            },
            progressbarId: function () {
                return ("misko" + this.data.column.headerText + Math.floor(Math.random() * 100)); 
            }
        }
    }
</script>

<style scoped>
</style>